import { useState, useEffect } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import ButtonIcon from "../../components/ButtonIcon";
import InputData from "../../components/InputData";
import Dropdown from "../../components/Dropdown";
import CheckBox from "../../components/CheckBox";
import DropdownFilter from "../../components/DropdownFilter";
import LogoImg from "./LogoImg";
import { post } from "../utils/api";
import PopupCP from "../../support-extra/components/PopupCP";
import ResetPasswordScreen from "./ResetPasswordScreen";

import "../css/UsersScreen.css";
import { provinceOptions, userData } from "../../js/utils";

const departamentoOptions = [
  { id: "", text: "" },
  { id: "CONTABILIDAD", text: "CONTABILIDAD" },
  { id: "MARKETING", text: "MARKETING" },
  { id: "INFORMÁTICA", text: "INFORMÁTICA" },
  { id: "LOGÍSTICA", text: "LOGÍSTICA" },
  { id: "VENTAS", text: "VENTAS" },
  { id: "ALMACÉN", text: "ALMACÉN" },
  { id: "DIRECCIÓN", text: "DIRECCIÓN" },
  { id: "TÉCNICO", text: "TÉCNICO" },
  { id: "ADMINISTRACIÓN", text: "ADMINISTRACIÓN" },
];

const tokenSesion = userData ? userData.token : "";
const userId = userData ? userData.id : "";

export default function UsersScreen(props) {
  const [id, setId] = useState(props.userId);
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [DNI, setDNI] = useState("");
  const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
  const [edad, setEdad] = useState(0);
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [direccion, setDireccion] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [provincia, setProvincia] = useState("");
  const [movil, setMovil] = useState("");
  const [email, setEmail] = useState("");
  const [optometrista, setOptometrista] = useState(false);
  const [numColegiadoOptometrista, setNumColegiadoOptometrista] = useState("");
  const [audioprotesista, setAudioprotesista] = useState(false);
  const [numColegiadoAudioprotesista, setNumColegiadoAudioprotesista] =
    useState("");
  const [areaVentas, setAreaVentas] = useState(false);
  const [otros, setOtros] = useState(false);
  const [departamento, setDepartamento] = useState("");
  const [activarControlLaboral, setActivarControlLaboral] = useState(false);
  const [empresa, setEmpresa] = useState(-1);
  const [nafNss, setNafNss] = useState("");
  const [pinControl, setPinControl] = useState("");
  const [accesoPacientes, setAccesoPacientes] = useState(false);
  const [accesoAgenda, setAccesoAgenda] = useState(false);
  const [accesoVentas, setAccesoVentas] = useState(false);
  const [accesoAlmacen, setAccesoAlmacen] = useState(false);
  const [accesoCRM, setAccesoCRM] = useState(false);
  const [accesoDashboard, setAccesoDashboard] = useState(false);
  const [accesoDocumentos, setAccesoDocumentos] = useState(false);
  const [accesoConfiguracion, setAccesoConfiguracion] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [bloqueado, setBloqueado] = useState(false);
  const [bloquearOpticas, setBloquearOpticas] = useState(false);
  const [opticas, setOpticas] = useState([]);

  const [employeePicture, setEmployeePicture] = useState(null);
  const employeePictureName = "foto-agente";
  const [flagNewEmployeePicture, setFlagNewEmployeePicture] = useState(false);
  const [flagDeleteEmployeePicture, setFlagDeleteEmployeePicture] =
    useState(false);

  const [listaOpticas, setListaOpticas] = useState([]);
  const [listaOpticasSelected, setListaOpticasSelected] = useState([]);
  const [listaOpticasSelectedEstado, setListaOpticasSelectedEstado] = useState(
    [],
  );

  const [listaEmpresas, setListaEmpresas] = useState();

  const [originalData, setOriginalData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [showPopupCP, setShowPopupCP] = useState(false);
  const [cpPopupAddress, setCPPopupAddress] = useState("");
  const [cpPopupCity, setCPPopupCity] = useState("");
  const [errorCP, setErrorCP] = useState(false);

  useEffect(() => {
    if (errorCP) {
      props.createPopupQuestion(
        "Por favor, revise el código postal.",
        () => {
          const el = document.getElementById("codigoPostal");
          if (el) {
            el.focus();
          }
          setErrorCP(false);
          props.removePopupQuestion();
          return;
        },
        null,
        "Entendido",
      );
    }
  }, [errorCP]);

  const [showPassword, setShowPassword] = useState(false);
  const [showResetPasswordPopup, setShowResetPasswordPopup] = useState(false);

  const [allAccessChecks, setAllAccessChecks] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        const dniInput = document.getElementById("dni");
        // Asegúrate de hacer focus al input o elemento interactivo
        if (dniInput) dniInput.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    async function loadUserData() {
      if (props.userId === -1) {
        setId(props.userId);
        setUsuario("");
        setPassword("");
        setDNI("");
        setFechaNacimiento("");
        setNombre("");
        setApellidos("");
        setDireccion("");
        setLocalidad("");
        setCodigoPostal("");
        setProvincia("");
        setMovil("");
        setEmail("");
        setOptometrista(false);
        setNumColegiadoOptometrista("");
        setAudioprotesista(false);
        setNumColegiadoAudioprotesista("");
        setAreaVentas(false);
        setDepartamento("");
        setEmpresa(-1);
        setNafNss("");
        setPinControl("");
        setAccesoPacientes(false);
        setAccesoAgenda(false);
        setAccesoVentas(false);
        setAccesoAlmacen(false);
        setAccesoCRM(false);
        setAccesoDashboard(false);
        setAccesoDocumentos(false);
        setAccesoConfiguracion(false);
        setAdmin(false);
        setBloqueado(false);
        setBloquearOpticas(false);
        setOpticas([]);

        const newUserData = {
          id: -1,
          usuario: "",
          password: "",
          DNI: "",
          fechaNacimiento: "",
          nombre: "",
          apellidos: "",
          direccion: "",
          localidad: "",
          codigoPostal: "",
          provincia: "",
          movil: "",
          email: "",
          optometrista: false,
          numColegiadoOptometrista: "",
          audioprotesista: false,
          numColegiadoAudioprotesista: "",
          areaVentas: false,
          departamento: "",
          empresa: -1,
          nafNss: "",
          pinControl: "",
          accesoPacientes: false,
          accesoAgenda: false,
          accesoVentas: false,
          accesoAlmacen: false,
          accesoCRM: false,
          accesoDashboard: false,
          accesoDocumentos: false,
          accesoConfiguracion: false,
          admin: false,
          bloqueado: false,
          bloquearOpticas: false,
          opticas: [],
        };

        setOriginalData(newUserData);

        return;
      }

      setIsLoading(true);

      let jsonUser = [];
      let jsonUserPhoto = [];

      let jsonQuery = {
        token: tokenSesion,
        id: props.userId,
      };

      jsonUser = await post(
        "Configuracion/ObtenerAgenteCompleto.php",
        jsonQuery,
      );

      if (jsonUser) {
        setId(jsonUser.id);
        setUsuario(jsonUser.usuario);
        setPassword(jsonUser.password);
        setDNI(jsonUser.dni);
        setFechaNacimiento(jsonUser.fechaNacimiento);
        setEdad(calcularEdad(jsonUser.fechaNacimiento));
        setNombre(jsonUser.nombre);
        setApellidos(jsonUser.apellidos);
        setDireccion(jsonUser.direccion);
        setLocalidad(jsonUser.localidad);
        setCodigoPostal(jsonUser.codigoPostal);
        setProvincia(jsonUser.provincia);
        setMovil(jsonUser.movil);
        setEmail(jsonUser.email);
        setOptometrista(Boolean(jsonUser.optometrista));
        setNumColegiadoOptometrista(jsonUser.numColegiadoOptometrista);
        setAudioprotesista(Boolean(jsonUser.audioprotesista));
        setNumColegiadoAudioprotesista(jsonUser.numColegiadoAudioprotesista);
        setAreaVentas(Boolean(jsonUser.areaVentas));
        setDepartamento(jsonUser.departamento.trim());
        setEmpresa(jsonUser.empresa);
        setNafNss(jsonUser.nafNss);
        setPinControl(jsonUser.pinControl);
        setAccesoPacientes(Boolean(jsonUser.accesoPacientes));
        setAccesoAgenda(Boolean(jsonUser.accesoAgenda));
        setAccesoVentas(Boolean(jsonUser.accesoVentas));
        setAccesoAlmacen(Boolean(jsonUser.accesoAlmacen));
        setAccesoCRM(Boolean(jsonUser.accesoCRM));
        setAccesoDashboard(Boolean(jsonUser.accesoDashboard));
        setAccesoDocumentos(Boolean(jsonUser.accesoDocumentos));
        setAccesoConfiguracion(Boolean(jsonUser.accesoConfiguracion));
        setAdmin(Boolean(jsonUser.admin));
        setBloqueado(Boolean(jsonUser.bloqueado));
        setBloquearOpticas(Boolean(jsonUser.bloquearOpticas));
        setOpticas(jsonUser.opticas);

        setListaOpticasSelectedEstado(jsonUser.opticas);

        const userData = {
          id: jsonUser.id,
          usuario: jsonUser.usuario,
          password: jsonUser.password,
          DNI: jsonUser.dni,
          fechaNacimiento: jsonUser.fechaNacimiento,
          nombre: jsonUser.nombre,
          apellidos: jsonUser.apellidos,
          direccion: jsonUser.direccion,
          localidad: jsonUser.localidad,
          codigoPostal: jsonUser.codigoPostal,
          provincia: jsonUser.provincia,
          movil: jsonUser.movil,
          email: jsonUser.email,
          optometrista: Boolean(jsonUser.optometrista),
          numColegiadoOptometrista: jsonUser.numColegiadoOptometrista,
          audioprotesista: Boolean(jsonUser.audioprotesista),
          numColegiadoAudioprotesista: jsonUser.numColegiadoAudioprotesista,
          areaVentas: Boolean(jsonUser.areaVentas),
          departamento: jsonUser.departamento.trim(),
          empresa: jsonUser.empresa,
          nafNss: jsonUser.nafNss,
          pinControl: jsonUser.pinControl,
          accesoPacientes: Boolean(jsonUser.accesoPacientes),
          accesoAgenda: Boolean(jsonUser.accesoAgenda),
          accesoVentas: Boolean(jsonUser.accesoVentas),
          accesoAlmacen: Boolean(jsonUser.accesoAlmacen),
          accesoCRM: Boolean(jsonUser.accesoCRM),
          accesoDashboard: Boolean(jsonUser.accesoDashboard),
          accesoDocumentos: Boolean(jsonUser.accesoDocumentos),
          accesoConfiguracion: Boolean(jsonUser.accesoConfiguracion),
          admin: Boolean(jsonUser.admin),
          bloqueado: Boolean(jsonUser.bloqueado),
          bloquearOpticas: Boolean(jsonUser.bloquearOpticas),
          opticas: jsonUser.opticas,
        };

        setOriginalData(userData);
      }

      let jsonQueryPicture = { token: tokenSesion, idAgente: props.userId };

      jsonUserPhoto = await post(
        "Configuracion/ObtenerFotoAgente.php",
        jsonQueryPicture,
      );

      if (jsonUserPhoto) {
        setEmployeePicture(jsonUserPhoto.foto);
        setFlagNewEmployeePicture(false);
      }

      setIsLoading(false);
    }
    loadUserData();
  }, [props.userId]);

  useEffect(() => {
    async function loadOpticsData() {
      let json_query = {
        token: tokenSesion,
        idEmpresa: "-1",
      };

      // console.log("JSON_QUERY_PERFILES_OPTICAS: ", json_query);

      let json_opticas = await post(
        "Configuracion/ListarOpticas.php",
        json_query,
      );

      // console.log("JSON_OPTICAS: ", json_opticas);

      if (Array.isArray(json_opticas)) {
        let opticsList = [];
        opticsList.push({ id: -1, text: "" });
        let opticsListSelected = [];
        for (const el of json_opticas) {
          let optica = { id: el.idOptica, text: el.nombre_corto };
          let optica_selected = {
            id: el.idOptica,
            text: el.nombre_corto,
            active: listaOpticasSelectedEstado.includes(el.idOptica),
          };
          opticsList.push(optica);
          opticsListSelected.push(optica_selected);
        }
        setListaOpticas(opticsList);
        setListaOpticasSelected(opticsListSelected);
      }
    }
    loadOpticsData();
  }, [props.userId]);

  useEffect(() => {
    async function loadCompaniesData() {
      let json_query = {
        token: tokenSesion,
      };

      let json_empresas = await post(
        "Configuracion/ListarEmpresas.php",
        json_query,
      );

      if (Array.isArray(json_empresas)) {
        let companiesList = [];

        for (const el of json_empresas) {
          let empresa = { id: el.idEmpresa, text: el.nombre_empresa };

          companiesList.push(empresa);
        }
        setListaEmpresas(companiesList);
      }
    }
    loadCompaniesData();
  }, [props.userId]);

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          discardChanges();
          props.removePopupQuestion();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  const hasChanges = () => {
    if (!originalData) {
      return false;
    }

    return (
      flagNewEmployeePicture ||
      usuario !== originalData.usuario ||
      password !== originalData.password ||
      DNI !== originalData.DNI ||
      fechaNacimiento !== originalData.fechaNacimiento ||
      nombre !== originalData.nombre ||
      apellidos !== originalData.apellidos ||
      direccion !== originalData.direccion ||
      localidad !== originalData.localidad ||
      codigoPostal !== originalData.codigoPostal ||
      provincia !== originalData.provincia ||
      movil !== originalData.movil ||
      email !== originalData.email ||
      optometrista !== originalData.optometrista ||
      numColegiadoOptometrista !== originalData.numColegiadoOptometrista ||
      audioprotesista !== originalData.audioprotesista ||
      numColegiadoAudioprotesista !==
        originalData.numColegiadoAudioprotesista ||
      areaVentas !== originalData.areaVentas ||
      departamento !== originalData.departamento ||
      empresa !== originalData.empresa ||
      nafNss !== originalData.nafNss ||
      pinControl !== originalData.pinControl ||
      accesoPacientes !== originalData.accesoPacientes ||
      accesoAgenda !== originalData.accesoAgenda ||
      accesoVentas !== originalData.accesoVentas ||
      accesoAlmacen !== originalData.accesoAlmacen ||
      accesoCRM !== originalData.accesoCRM ||
      accesoDashboard !== originalData.accesoDashboard ||
      accesoDocumentos !== originalData.accesoDocumentos ||
      accesoConfiguracion !== originalData.accesoConfiguracion ||
      admin !== originalData.admin ||
      bloqueado !== originalData.bloqueado ||
      bloquearOpticas !== originalData.bloquearOpticas ||
      JSON.stringify(opticas) !== JSON.stringify(originalData.opticas)
    );
  };

  const discardChanges = () => {
    if (originalData) {
      setUsuario(originalData.usuario);
      setPassword(originalData.password);
      setDNI(originalData.DNI);
      setFechaNacimiento(originalData.fechaNacimiento);
      setEdad(calcularEdad(originalData.fechaNacimiento));
      setNombre(originalData.nombre);
      setApellidos(originalData.apellidos);
      setDireccion(originalData.direccion);
      setLocalidad(originalData.localidad);
      setCodigoPostal(originalData.codigoPostal);
      setProvincia(originalData.provincia);
      setMovil(originalData.movil);
      setEmail(originalData.email);
      setOptometrista(originalData.optometrista);
      setNumColegiadoOptometrista(originalData.numColegiadoOptometrista);
      setAudioprotesista(originalData.audioprotesista);
      setNumColegiadoAudioprotesista(originalData.numColegiadoAudioprotesista);
      setAreaVentas(originalData.areaVentas);
      setDepartamento(originalData.departamento);
      setEmpresa(originalData.empresa);
      setNafNss(originalData.nafNss);
      setPinControl(originalData.pinControl);
      setAccesoPacientes(originalData.accesoPacientes);
      setAccesoAgenda(originalData.accesoAgenda);
      setAccesoVentas(originalData.accesoVentas);
      setAccesoAlmacen(originalData.accesoAlmacen);
      setAccesoCRM(originalData.accesoCRM);
      setAccesoDashboard(originalData.accesoDashboard);
      setAccesoDocumentos(originalData.accesoDocumentos);
      setAccesoConfiguracion(originalData.accesoConfiguracion);
      setAdmin(originalData.admin);
      setBloqueado(originalData.bloqueado);
      setBloquearOpticas(originalData.bloquearOpticas);
      setOpticas(originalData.opticas);
    } else {
      setUsuario("");
      setPassword("");
      setDNI("");
      setFechaNacimiento("");
      setNombre("");
      setApellidos("");
      setDireccion("");
      setLocalidad("");
      setCodigoPostal("");
      setProvincia("");
      setMovil("");
      setEmail("");
      setOptometrista(false);
      setNumColegiadoOptometrista("");
      setAudioprotesista(false);
      setNumColegiadoAudioprotesista("");
      setAreaVentas(false);
      setDepartamento("");
      setEmpresa(-1);
      setNafNss("");
      setPinControl("");
      setAccesoPacientes(false);
      setAccesoAgenda(false);
      setAccesoVentas(false);
      setAccesoAlmacen(false);
      setAccesoCRM(false);
      setAccesoDashboard(false);
      setAccesoDocumentos(false);
      setAccesoConfiguracion(false);
      setAdmin(false);
      setBloqueado(false);
      setBloquearOpticas(false);
      setOpticas([]);
    }

    props.closeFunction();
  };

  const saveUserData = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        id: id,
        usuario: usuario,
        password: password,
        dni: DNI,
        fechaNacimiento: fechaNacimiento,
        nombre: nombre,
        apellidos: apellidos,
        direccion: direccion,
        localidad: localidad,
        codigoPostal: codigoPostal,
        provincia: provincia,
        movil: movil,
        email: email,
        optometrista: optometrista,
        numColegiadoOptometrista: numColegiadoOptometrista,
        audioprotesista: audioprotesista,
        numColegiadoAudioprotesista: numColegiadoAudioprotesista,
        areaVentas: areaVentas,
        departamento: departamento,
        idEmpresa: empresa,
        nafNss: nafNss,
        pinControl: pinControl,
        accesoPacientes: accesoPacientes,
        accesoAgenda: accesoAgenda,
        accesoVentas: accesoVentas,
        accesoAlmacen: accesoAlmacen,
        accesoCRM: accesoCRM,
        accesoDashboard: accesoDashboard,
        accesoDocumentos: accesoDocumentos,
        accesoConfiguracion: accesoConfiguracion,
        admin: admin,
        bloqueado: bloqueado,
        bloquearOpticas: bloquearOpticas,
        opticas: listaOpticasSelectedEstado,
      };

      let newUserId = -1;
      let error = "";

      // console.log("JSON_QUERY_AGENTE: ", json_query);

      await post("Configuracion/GuardarAgente.php", json_query).then((data) => {
        newUserId = data.id;
        error = data.error;
      });

      if (newUserId === -1) {
        // console.log(error);
        props.createPopupQuestion(
          `Ocurrió un error al grabar los datos.`,
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      } else {
        if (flagNewEmployeePicture) {
          let json_upload_picture = {
            token: tokenSesion,
            idAgente: newUserId,
            imagen: employeePicture,
          };

          // console.log("JSON_PICTURE: ", json_upload_picture);

          await post("Configuracion/SubirFotoAgente.php", json_upload_picture);
        }

        if (flagDeleteEmployeePicture) {
          let json_delete_picture = {
            token: tokenSesion,
            idAgente: props.userId,
          };

          await post(
            "Configuracion/EliminarFotoAgente.php",
            json_delete_picture,
          );
        }

        // Avisamos al padre que se guardó correctamente
        if (props.onSave) {
          props.onSave(newUserId);
        }
        return true;
      }
    }
  };

  const deleteUserData = async () => {
    let json_query = { token: tokenSesion, idAgente: id, idUsuario: userId };
    let deleteError = "";

    await post("Configuracion/EliminarAgente.php", json_query).then((data) => {
      deleteError = data;
    });

    // console.log("ERROR: ", deleteError);

    if (deleteError !== "") {
      props.createPopupQuestion(
        deleteError,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return false;
    } else {
      if (props.onDelete) {
        props.onDelete();
      }
      return true;
    }
  };

  const deleteEmployeePicture = () => {
    setEmployeePicture(null);
    setFlagDeleteEmployeePicture(true);
  };

  const minimunData = () => {
    return (
      nombre?.trim() ||
      apellidos?.trim() ||
      DNI?.trim() ||
      usuario?.trim() ||
      password?.trim() ||
      opticas?.length ||
      pinControl?.trim() ||
      (optometrista && numColegiadoOptometrista?.trim()) ||
      (audioprotesista && numColegiadoAudioprotesista?.trim())
    );
  };

  const addJornada = () => {};

  const openResetPasswordPopup = () => {
    setShowResetPasswordPopup(true);
  };

  const closeResetPasswordPopup = () => {
    setShowResetPasswordPopup(false);
  };

  const calcularEdad = (fechNac) => {
    const hoy = new Date();
    const nacimiento = new Date(fechNac);

    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const difMeses = hoy.getMonth() - nacimiento.getMonth();

    if (
      difMeses < 0 ||
      (difMeses === 0 && hoy.getDate() < nacimiento.getDate())
    ) {
      edad--;
    }

    return edad;
  };

  const checkAccessChecked = () => {
    let allChecksState =
      accesoPacientes &&
      accesoAgenda &&
      accesoAlmacen &&
      accesoVentas &&
      accesoCRM &&
      accesoDashboard &&
      accesoDocumentos &&
      accesoConfiguracion;

    setAllAccessChecks(allChecksState);
  };

  const setAccessChecks = (opt) => {
    setAccesoPacientes(opt);
    setAccesoAgenda(opt);
    setAccesoAlmacen(opt);
    setAccesoVentas(opt);
    setAccesoCRM(opt);
    setAccesoDashboard(opt);
    setAccesoDocumentos(opt);
    setAccesoConfiguracion(opt);
  };

  const showPopupCPDialog = (show, address, city) => {
    setCPPopupAddress(address);
    setCPPopupCity(city);
    setShowPopupCP(show);
  };

  const onAcceptCP = (fullAddress) => {
    setCodigoPostal(fullAddress.postalCode);
    showPopupCPDialog(false, "", "");
  };

  if (isLoading) {
    return <></>;
  }

  return (
    <div className="settings-user-popup-container">
      <div className="settings-user-popup-screen">
        <div className="settings-user-popup-screen-header">
          <button className="popup-action-icon close-icon">
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt="Icon"
              onClick={() => {
                handleClose();
              }}
            ></img>
          </button>
          <span className="popup-screen-header-title">Datos de agente</span>
        </div>
        <div className="settings-user-section-content">
          <div className="settings-user-container-block">
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Datos personales</span>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-personal-data-section">
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-large">
                    <span className="settings-label">DNI (*)</span>
                    <InputData
                      tabIndex={1}
                      id="dni"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={DNI}
                      onChange={(e) => {
                        setDNI(e);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-large">
                    <div className="settings-user-data-field settings-d-user-small">
                      <span className="settings-label">F. Nacimiento</span>
                      <InputData
                        tabIndex={2}
                        id="fnacimiento"
                        type="date"
                        size={6}
                        input={fechaNacimiento}
                        onChange={(e) => {
                          setFechaNacimiento(e);
                          setEdad(calcularEdad(e));
                        }}
                      />
                    </div>
                    <div className="settings-user-data-field-extra settings-d-user-small">
                      <span className="settings-label">Edad</span>
                      <InputData
                        inactive={true}
                        tabIndex={-1}
                        id="edad"
                        type="numeric"
                        size={6}
                        input={edad}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Nombre (*)</span>
                    <InputData
                      tabIndex={3}
                      id="nombre"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={nombre}
                      onChange={(e) => {
                        setNombre(e);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Apellidos (*)</span>
                    <InputData
                      tabIndex={4}
                      id="apellidos"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={apellidos}
                      onChange={(e) => {
                        setApellidos(e);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Direccion</span>
                    <InputData
                      tabIndex={5}
                      id="direccion"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={direccion}
                      onChange={(e) => {
                        setDireccion(e);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Localidad</span>
                    <InputData
                      tabIndex={6}
                      id="localidad"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={localidad}
                      onChange={(e) => {
                        setLocalidad(e);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">C. Postal</span>
                    <InputData
                      tabIndex={7}
                      id="codigoPostal"
                      type="type-cp"
                      maxLength={5}
                      size={6}
                      input={codigoPostal}
                      onChange={(e) => {
                        setCodigoPostal(e);
                      }}
                      onMalformed={() => setErrorCP(true)}
                      error={errorCP}
                      icon="/images/link.svg"
                      onClick={() =>
                        showPopupCPDialog(true, direccion, localidad)
                      }
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Provincia</span>
                    <Dropdown
                      tabIndex={8}
                      id="provincia"
                      disabled={false}
                      optionList={provinceOptions}
                      size={0}
                      op={provincia}
                      onChange={(e) => {
                        setProvincia(e.text);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-user-data-field-row">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Móvil</span>
                    <InputData
                      tabIndex={9}
                      id="movil"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={movil}
                      onChange={(e) => {
                        setMovil(e);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Email</span>
                    <InputData
                      tabIndex={10}
                      id="email"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={email}
                      onChange={(e) => {
                        setEmail(e);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="settings-user-picture-section">
                <div className="patient-info-1">
                  <LogoImg
                    id="employee-picture"
                    img={employeePicture}
                    onUpload={(img) => {
                      setEmployeePicture(img);
                      setFlagNewEmployeePicture(true);
                    }}
                    onDelete={() => {
                      props.createPopupQuestion(
                        `¿Desea eliminar la imagen actual?`,
                        async () => {
                          deleteEmployeePicture();
                          props.removePopupQuestion();
                        },
                        props.removePopupQuestion,
                        "Sí",
                        "No",
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/*<div className="settings-user-container-block">
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Área profesional (Opción A)</span>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-area-profesional-section">
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">NC CGCOO (*)</span>
                  <InputData
                    tabIndex={12}
                    id="numColegiadoOptometrista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoOptometrista}
                    onChange={(e) => {
                      setNumColegiadoOptometrista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">Departamento</span>
                  <InputData
                    tabIndex={13}
                    id="numColegiadoAudioprotesista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoAudioprotesista}
                    onChange={(e) => {
                      setNumColegiadoAudioprotesista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">Optometrista</span>
                  <CheckBox
                    id="optometrista"
                    tabIndex={14}
                    active={optometrista}
                    onClick={() => {
                      setOptometrista(!optometrista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">Área de ventas</span>
                  <CheckBox
                    id="areaVentas"
                    tabIndex={15}
                    active={areaVentas}
                    onClick={() => {
                      setAreaVentas(!areaVentas);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">NC Audio (*)</span>
                  <InputData
                    tabIndex={16}
                    id="numColegiadoAudioprotesista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoAudioprotesista}
                    onChange={(e) => {
                      setNumColegiadoAudioprotesista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item" />
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">Audioprotesista</span>
                  <CheckBox
                    id="audioprotesista"
                    tabIndex={17}
                    active={audioprotesista}
                    onClick={() => {
                      setAudioprotesista(!audioprotesista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item">
                  <span className="settings-label">Otros</span>
                  <CheckBox
                    id="areaVentas"
                    tabIndex={18}
                    active={areaVentas}
                    onClick={() => {
                      setAreaVentas(!areaVentas);
                    }}
                  />
                </div>
              </div>
            </div>
          </div> */}
          <div className="settings-user-container-block">
            {/* ****************************************************** ÁREA PROFESIONAL (OPCIÓN B) */}
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Área profesional</span>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-area-profesional-section-b">
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">Optometrista</span>
                  <CheckBox
                    id="optometrista"
                    tabIndex={11}
                    active={optometrista}
                    onClick={() => {
                      setOptometrista(!optometrista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">Audioprotesista</span>
                  <CheckBox
                    id="audioprotesista"
                    tabIndex={13}
                    active={audioprotesista}
                    onClick={() => {
                      setAudioprotesista(!audioprotesista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">Otros</span>
                  <CheckBox
                    id="otros"
                    tabIndex={15}
                    active={departamento.trim() !== ""}
                    onClick={() => {
                      if (otros) {
                        setDepartamento("");
                        setOtros(false);
                      } else {
                        setOtros(!otros);
                      }
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">Área de ventas</span>
                  <CheckBox
                    id="areaVentas"
                    tabIndex={17}
                    active={areaVentas}
                    onClick={() => {
                      setAreaVentas(!areaVentas);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">NC CGCOO (*)</span>
                  <InputData
                    tabIndex={12}
                    id="numColegiadoOptometrista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoOptometrista}
                    onChange={(e) => {
                      setNumColegiadoOptometrista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">NC Audio (*)</span>
                  <InputData
                    tabIndex={14}
                    id="numColegiadoAudioprotesista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoAudioprotesista}
                    onChange={(e) => {
                      setNumColegiadoAudioprotesista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label-b">Departamento</span>
                  <Dropdown
                    tabIndex={16}
                    id="departamento"
                    disabled={false}
                    optionList={departamentoOptions}
                    size={0}
                    op={departamento}
                    onChange={(e) => {
                      setDepartamento(e.text);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b" />
              </div>
            </div>
          </div>
          {/*<div className="settings-user-container-block">
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Área profesional (Opción C)</span>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-area-profesional-section-c">
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">Optometrista</span>
                  <CheckBox
                    id="optometrista"
                    tabIndex={14}
                    active={optometrista}
                    onClick={() => {
                      setOptometrista(!optometrista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">NC CGCOO (*)</span>
                  <InputData
                    tabIndex={12}
                    id="numColegiadoOptometrista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoOptometrista}
                    onChange={(e) => {
                      setNumColegiadoOptometrista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">Área de ventas</span>
                  <CheckBox
                    id="areaVentas"
                    tabIndex={15}
                    active={areaVentas}
                    onClick={() => {
                      setAreaVentas(!areaVentas);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c" />
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">Audioprotesista</span>
                  <CheckBox
                    id="audioprotesista"
                    tabIndex={17}
                    active={audioprotesista}
                    onClick={() => {
                      setAudioprotesista(!audioprotesista);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">NC Audio (*)</span>
                  <InputData
                    tabIndex={16}
                    id="numColegiadoAudioprotesista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoAudioprotesista}
                    onChange={(e) => {
                      setNumColegiadoAudioprotesista(e);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">Otros</span>
                  <CheckBox
                    id="areaVentas"
                    tabIndex={18}
                    active={areaVentas}
                    onClick={() => {
                      setAreaVentas(!areaVentas);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-c">
                  <span className="settings-label">Departamento</span>
                  <InputData
                    tabIndex={13}
                    id="numColegiadoAudioprotesista"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={numColegiadoAudioprotesista}
                    onChange={(e) => {
                      setNumColegiadoAudioprotesista(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div> */}
          <div className="settings-user-container-block">
            <div className="settings-jornada-laboral">
              <span className="settings-user-h3-black">Jornada laboral</span>
              <div className="empresas-opticas-options">
                <div className="general-header-separator" />
                <ButtonIcon
                  text="Jornada"
                  icon="/images/add-white.svg"
                  onClick={() => {
                    addJornada();
                  }}
                />
              </div>
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-data-field-row">
                <div className="settings-user-data-field settings-d-user-small">
                  <span className="settings-label">Activar control</span>
                  <CheckBox
                    id="activarJornada"
                    tabIndex={18}
                    active={activarControlLaboral}
                    onClick={() => {
                      setActivarControlLaboral(!activarControlLaboral);
                    }}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">Empresa (*)</span>
                  <Dropdown
                    tabIndex={19}
                    id="empresa"
                    disabled={false}
                    optionList={listaEmpresas}
                    size={0}
                    op={empresa}
                    onChange={(e) => {
                      setEmpresa(e.id);
                    }}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">NAF / NSS (*)</span>
                  <InputData
                    tabIndex={20}
                    id="pinControl"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={nafNss}
                    onChange={(e) => {
                      setNafNss(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="settings-user-container-block">
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Usuario y permisos</span>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            {/* ************************************************************************************************** */}
            <div className="settings-user-login-block">
              <div className="settings-user-data-field-row">
                <div className="settings-user-login-data-block">
                  <div className="settings-user-data-field settings-d-user-large">
                    <span className="settings-label">Usuario login (*)</span>
                    <InputData
                      tabIndex={21}
                      id="login"
                      type="type-type-alphanum-ext"
                      dontForceUppercase={true}
                      size={6}
                      input={usuario}
                      onChange={(e) => {
                        setUsuario(e);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-large">
                    <span className="settings-label">Contraseña login (*)</span>
                    <InputData
                      tabIndex={22}
                      id="password"
                      type={showPassword ? "text" : "password"}
                      dontForceUppercase={true}
                      size={6}
                      input={password}
                      onChange={(e) => {
                        setPassword(e);
                      }}
                      inactive={props.userId !== -1}
                      icon={
                        props.userId === -1
                          ? showPassword
                            ? "/images/no-eye-passwd.png"
                            : "/images/eye-passwd.png"
                          : null
                      }
                      onClick={() => {
                        setShowPassword(!showPassword);
                      }}
                    />
                    <ButtonIconH
                      text="Cambiar"
                      disabled={props.userId === -1}
                      onClick={() => {
                        openResetPasswordPopup();
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-large">
                    <span className="settings-label">Ópticas (*)</span>
                    <DropdownFilter
                      size={0}
                      tabIndex={23}
                      disabled={false}
                      optionList={listaOpticasSelected}
                      op={"ÓPTICAS"}
                      selectedOptions={listaOpticasSelectedEstado}
                      onChange={(e) => {
                        const updatedOpticasSelectedEstado =
                          listaOpticasSelectedEstado.includes(e.id)
                            ? listaOpticasSelectedEstado.filter(
                                (p) => p !== e.id,
                              )
                            : [...listaOpticasSelectedEstado, e.id];
                        setListaOpticasSelectedEstado(
                          updatedOpticasSelectedEstado,
                        );
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-large">
                    <span className="settings-label">Pin control (4-6) (*)</span>
                    <InputData
                      tabIndex={24}
                      id="pinControl"
                      type="type-type-alphanum-ext"
                      size={6}
                      input={pinControl}
                      onChange={(e) => {
                        setPinControl(e);
                      }}
                    />
                  </div>
                </div>
                <div className="settings-user-login-data-block">
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Usuario bloqueado</span>
                    <CheckBox
                      id="bloqueado"
                      tabIndex={25}
                      active={bloqueado}
                      onClick={() => {
                        setBloqueado(!bloqueado);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Usuario administrador</span>
                    <CheckBox
                      id="administrador"
                      tabIndex={26}
                      active={admin}
                      onClick={() => {
                        setAdmin(!admin);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium">
                    <span className="settings-label">Bloquear ópticas</span>
                    <CheckBox
                      id="bloquearOpticas"
                      tabIndex={27}
                      active={bloquearOpticas}
                      onClick={() => {
                        setBloquearOpticas(!bloquearOpticas);
                      }}
                    />
                  </div>
                  <div className="settings-user-data-field settings-d-user-medium" />
                </div>
              </div>
            </div>
            {/* ************************************************************************************************** */}
            {/*<div className="settings-user-login-block">
              <div className="settings-user-data-field-row">
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">Usuario login (*)</span>
                  <InputData
                    tabIndex={10}
                    id="login"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={usuario}
                    onChange={(e) => {
                      setUsuario(e);
                    }}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-medium">
                  <span className="settings-label">Usuario bloqueado</span>
                  <CheckBox
                    id="bloqueado"
                    tabIndex={18}
                    active={bloqueado}
                    onClick={() => {
                      setBloqueado(!bloqueado);
                    }}
                  />
                </div>
              </div>
              <div className="settings-user-data-field-row">
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">Contraseña login (*)</span>
                  <InputData
                    tabIndex={10}
                    id="password"
                    type="password"
                    size={6}
                    input={password}
                    onChange={(e) => {
                      setPassword(e);
                    }}
                    inactive={props.userId !== -1}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-medium">
                  <span className="settings-label">Usuario administrador</span>
                  <CheckBox
                    id="administrador"
                    tabIndex={18}
                    active={admin}
                    onClick={() => {
                      setAdmin(!admin);
                    }}
                  />
                </div>
              </div>
              <div className="settings-user-data-field-row">
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">Ópticas (*)</span>
                  <DropdownFilter
                    disabled={false}
                    optionList={listaOpticasSelected}
                    op={"ÓPTICAS"}
                    selectedOptions={listaOpticasSelectedEstado}
                    onChange={(e) => {
                      const updatedOpticasSelectedEstado =
                        listaOpticasSelectedEstado.includes(e.id)
                          ? listaOpticasSelectedEstado.filter((p) => p !== e.id)
                          : [...listaOpticasSelectedEstado, e.id];
                      setListaOpticasSelectedEstado(
                        updatedOpticasSelectedEstado,
                      );
                    }}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-medium">
                  <span className="settings-label">Bloquear ópticas</span>
                  <CheckBox
                    id="bloquearOpticas"
                    tabIndex={18}
                    active={bloquearOpticas}
                    onClick={() => {
                      setBloquearOpticas(!bloquearOpticas);
                    }}
                  />
                </div>
              </div>
              <div className="settings-user-data-field-row">
                <div className="settings-user-data-field settings-d-user-large">
                  <span className="settings-label">Pin control (4-6) (*)</span>
                  <InputData
                    tabIndex={10}
                    id="pinControl"
                    type="type-type-alphanum-ext"
                    size={6}
                    input={pinControl}
                    onChange={(e) => {
                      setPinControl(e);
                    }}
                  />
                </div>
                <div className="settings-user-data-field settings-d-user-medium" />
              </div>
            </div>*/}
            {/* ************************************************************************************************** */}
          </div>
          <div className="settings-user-container-block">
            <div className="settings-user-data-field-row">
              <span className="settings-user-h3-black">Control de acceso</span>
              <div className="settings-user-check-all">
                <span className="settings-label">Activar / Desactivar todo</span>
                <CheckBox
                  tabIndex={28}
                  id="accesos"
                  active={allAccessChecks}
                  onClick={() => {
                    setAllAccessChecks(!allAccessChecks);
                    setAccessChecks(!allAccessChecks);
                  }}
                />
              </div>
            </div>
            <div className="settings-user-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="settings-user-section-block">
              <div className="settings-user-area-profesional-section-b">
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Pacientes</span>
                  <CheckBox
                    id="accesoPacientes"
                    tabIndex={29}
                    active={accesoPacientes}
                    onClick={() => {
                      setAccesoPacientes(!accesoPacientes);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Agenda</span>
                  <CheckBox
                    id="accesoAgenda"
                    tabIndex={30}
                    active={accesoAgenda}
                    onClick={() => {
                      setAccesoAgenda(!accesoAgenda);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Ventas</span>
                  <CheckBox
                    id="accesoVentas"
                    tabIndex={31}
                    active={accesoVentas}
                    onClick={() => {
                      setAccesoVentas(!accesoVentas);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Almacén</span>
                  <CheckBox
                    id="accesoAlmacen"
                    tabIndex={32}
                    active={accesoAlmacen}
                    onClick={() => {
                      setAccesoAlmacen(!accesoAlmacen);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">CRM</span>
                  <CheckBox
                    id="accesoCRM"
                    tabIndex={33}
                    active={accesoCRM}
                    onClick={() => {
                      setAccesoCRM(!accesoCRM);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Dashboard</span>
                  <CheckBox
                    id="accesoDashboard"
                    tabIndex={34}
                    active={accesoDashboard}
                    onClick={() => {
                      setAccesoDashboard(!accesoDashboard);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Documentos</span>
                  <CheckBox
                    id="accesoDocumentos"
                    tabIndex={35}
                    active={accesoDocumentos}
                    onClick={() => {
                      setAccesoDocumentos(!accesoDocumentos);
                    }}
                  />
                </div>
                <div className="settings-user-area-profesional-item-b">
                  <span className="settings-label">Configuración</span>
                  <CheckBox
                    id="accesoConfiguracion"
                    tabIndex={36}
                    active={accesoConfiguracion}
                    onClick={() => {
                      setAccesoConfiguracion(!accesoConfiguracion);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-row-buttons-container">
          <div className="popup-row-buttons profile-menu">
            <ButtonIconH
              text="Cancelar"
              onClick={() => {
                handleClose();
              }}
            />
            <ButtonIconH
              text="Guardar"
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea guardar los cambios realizados en este perfil?`,
                  async () => {
                    const guardadoExitoso = await saveUserData();

                    if (guardadoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
            <ButtonIconH
              text="Eliminar"
              disabled={id === -1}
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea eliminar el perfil actual?`,
                  async () => {
                    const borradoExitoso = await deleteUserData();

                    if (borradoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
          </div>
        </div>
      </div>
      <PopupCP
        show={showPopupCP}
        direccion={cpPopupAddress}
        localidad={cpPopupCity}
        onAccept={(fullAddress) => onAcceptCP(fullAddress)}
        onCancel={() => showPopupCPDialog(false, "", "")}
      />
      {showResetPasswordPopup && (
        <ResetPasswordScreen
          {...props}
          show={showResetPasswordPopup}
          closeFunction={closeResetPasswordPopup}
        />
      )}
    </div>
  );
}
